import React from 'react';
import Grid from '@mui/material/Grid';
import Card from '@mui/material/Card';
import Typography from '@mui/material/Typography';
import Chip from '@mui/material/Chip';
import tokens from '../../theme/tokens';
import { VALORES } from './torneioInfo';

const PriceList = () => (
  <Grid container spacing={2}>
    {VALORES.map((item) => (
      <Grid item xs={12} sm={4} key={item.titulo}>
        <Card sx={{ p: 2.5, height: '100%', borderColor: item.destaque ? tokens.color.brand : undefined, borderWidth: item.destaque ? 2 : 1 }}>
          {item.destaque && <Chip size="small" color="primary" label="Mais escolhido" sx={{ mb: 1 }} />}
          <Typography color="text.secondary" fontWeight={600}>{item.titulo}</Typography>
          <Typography sx={{ fontFamily: tokens.font.display, fontWeight: 700, fontSize: '2rem' }}>{item.valor}</Typography>
          {item.detalhe && <Typography variant="body2" color="text.secondary">{item.detalhe}</Typography>}
        </Card>
      </Grid>
    ))}
  </Grid>
);

export default PriceList;
